module.exports = __webpack_public_path__ + "static/assistance-mobile-en-a496437f7bbd22919528002a9ab096fe.png";